<template>
  <Layout class="layout_simple">
    <template v-slot:main>
      <div class="section">
        <Title>
          {{ title }}
        </Title>
        <Subtitle>
          {{ desc }}
        </Subtitle>
      </div>
      <div class="section section_flex-center">
        <svg class="error-svg" viewBox="0 0 300 497" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
              d="M297.928 0.00292818L2.20416 0.424881C1.09959 0.426457 0.20544 1.32316 0.207016 2.42773L0.216789 9.27693C0.218365 10.3815 1.11507 11.2756 2.21964 11.2741L297.944 10.8521C299.048 10.8505 299.943 9.95384 299.941 8.84927L299.931 2.00007C299.93 0.895504 299.033 0.00135211 297.928 0.00292818Z"
              fill="#707070"/>
          <path
              d="M58 74.0405H2C0.895431 74.0405 0 74.936 0 76.0405L0 83.0405C0 84.1451 0.895432 85.0405 2 85.0405H58C59.1046 85.0405 60 84.1451 60 83.0405V76.0405C60 74.936 59.1046 74.0405 58 74.0405Z"
              fill="#DADADA"/>
          <path
              d="M298 48.0405H242C240.895 48.0405 240 48.936 240 50.0405V57.0405C240 58.1451 240.895 59.0405 242 59.0405H298C299.105 59.0405 300 58.1451 300 57.0405V50.0405C300 48.936 299.105 48.0405 298 48.0405Z"
              fill="#DADADA"/>
          <path
              d="M298 459H2C0.89543 459 0 459.895 0 461L0 468C0 469.105 0.895429 470 2 470H298C299.105 470 300 469.105 300 468V461C300 459.895 299.105 459 298 459Z"
              fill="#DADADA"/>
          <path
              d="M202.492 486.123H98C96.8954 486.123 96 487.018 96 488.123V494.972C96 496.077 96.8954 496.972 98 496.972H202.492C203.597 496.972 204.492 496.077 204.492 494.972V488.123C204.492 487.018 203.597 486.123 202.492 486.123Z"
              fill="#DADADA"/>
          <path
              d="M185.85 293.617L158.783 266.55C156.367 268.483 153.587 270.014 150.446 271.142C147.304 272.269 143.961 272.833 140.417 272.833C131.636 272.833 124.206 269.792 118.125 263.708C112.045 257.624 109.003 250.194 109 241.417C109 232.636 112.042 225.206 118.125 219.125C124.209 213.045 131.639 210.003 140.417 210C149.197 210 156.628 213.042 162.708 219.125C168.788 225.209 171.83 232.639 171.833 241.417C171.833 244.961 171.269 248.304 170.142 251.446C169.014 254.588 167.483 257.367 165.55 259.783L192.737 286.971C193.624 287.857 194.067 288.944 194.067 290.233C194.067 291.522 193.583 292.65 192.617 293.617C191.731 294.503 190.603 294.946 189.233 294.946C187.864 294.946 186.736 294.503 185.85 293.617ZM140.417 263.167C146.458 263.167 151.595 261.051 155.825 256.821C160.056 252.59 162.17 247.455 162.167 241.417C162.167 235.375 160.051 230.239 155.82 226.008C151.59 221.777 146.455 219.663 140.417 219.667C134.375 219.667 129.239 221.782 125.008 226.013C120.777 230.244 118.663 235.378 118.667 241.417C118.667 247.458 120.782 252.595 125.013 256.825C129.244 261.056 134.378 263.17 140.417 263.167Z"
              fill="#F77347"/>
        </svg>
      </div>
    </template>
  </Layout>
</template>

<script>
import {VIEWS} from '@/views/names'
import Layout from '@/app/components/Layout'
import Title from '@/app/components/Title.vue'
import Subtitle from '@/app/components/Subtitle.vue'

export default {
  name: VIEWS.error.name,
  components: {
    Subtitle,
    Title,
    Layout
  },
  props: {
    title: {
      type: String,
      required: true
    },
    desc: {
      type: String,
      required: true
    }
  }
}
</script>
